module.exports = __webpack_public_path__ + "static/media/nerd.82763d26.svg";